import { motion } from "framer-motion";
import ContactInquiryAside from "@/components/contact/ContactInquiryAside";
import ContactInquiryForm from "@/components/contact/ContactInquiryForm";

export default function ContactSection() {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:items-stretch">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="md:col-span-5 flex flex-col"
          >
            <ContactInquiryAside />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="md:col-span-7"
          >
            <ContactInquiryForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
